__turbopack_context__.v({
  "carousel": "Products-module__zL8ORa__carousel",
  "link": "Products-module__zL8ORa__link",
  "media": "Products-module__zL8ORa__media",
  "root": "Products-module__zL8ORa__root",
});
